import { render, staticRenderFns } from "./authCallback.vue?vue&type=template&id=0aca2cca&scoped=true"
import script from "./authCallback.vue?vue&type=script&lang=js"
export * from "./authCallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aca2cca",
  null
  
)

export default component.exports